import React from 'react';
import {Construction} from '@mui/icons-material';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Construction style={{ fontSize: 100, marginBottom: 20 }} />
        Website is under construction. Come back later :)
      </header>
    </div>
  );
}

export default App;
